import React from 'react';
import { useUploadDocuments } from './useUploadDocuments';
import { MultiplePreviewModal } from './MultiplePreviewModal';
import { DocumentsUploaderErrorModal } from './DocumentsUploaderErrorModal';
import { ContractSigningForm } from './ContractSigningForm';

function DocumentsUploaderHeader() {
  return (
    <div className="text-center mb-6">
      {/* TODO: src should be determined by storage url given by backend */}
      <img
        src="/static/img/illustrations/person-upload-window.svg"
        alt=""
        width={140}
      />
    </div>
  );
}

function DocumentsUploaderTitle() {
  return (
    <h1 className="fs-5 text-primary text-center mb-6">
      Proceso de firma
    </h1>
  );
}

function DocumentsUploaderFormActions({ isDisabled }: { isDisabled: boolean }) {
  return (
    <div className="row justify-content-center gy-4">
      <div className="col-md-6 col-lg-5">
        <a className="btn btn-outline-primary w-100" href="/cms/signer">
          Volver
        </a>
      </div>
      <div className="col-md-6 col-lg-5">
        <button
          className="btn btn-primary w-100"
          type="submit"
          disabled={isDisabled}
        >
          Obtener link
        </button>
      </div>
    </div>
  );
}

export function DocumentsUploader() {
  const {
    form,
    handleSubmit,
    modal,
    previewDocuments,
    handleCloseModal,
    handleCloseErrorModal,
    handleSendDocuments,
    isLoadingUpload,
    isPreviewButtonDisabled,
    descriptiveError,
  } = useUploadDocuments();

  return (
    <section className="row justify-content-center gx-0">
      <div className="col-md-10 col-lg-8 col-xl-6">
        <div className="card shadow-drop">
          <div className="card-body p-6">
            <DocumentsUploaderHeader />
            <DocumentsUploaderTitle />
            <ContractSigningForm form={form} onSubmit={handleSubmit}>
              <DocumentsUploaderFormActions isDisabled={isPreviewButtonDisabled} />
            </ContractSigningForm>
          </div>
        </div>
        {/* This modal is used to preview the documents that the user has uploaded
        when data is already validated via zod schema. It means that the user
        has already uploaded the documents and now is just previewing them.
        The user can send the documents to the backend by clicking on the button
        "Enviar", that is inside the modal.
        The function that handles the sending of the documents
        is provided by the hook useUploadDocuments.
        */}
        <MultiplePreviewModal
          isOpen={modal === 'documentsPreview'}
          handleSendDocuments={handleSendDocuments}
          handleCloseMultiplePreview={handleCloseModal}
          documents={previewDocuments}
          isLoadingUpload={isLoadingUpload}
        />
      </div>
      <DocumentsUploaderErrorModal
        show={modal === 'error'}
        onHide={handleCloseErrorModal}
        reason={descriptiveError?.extended_errors?.reason}
        description={descriptiveError?.extended_errors?.description}
      />
    </section>
  );
}
